import React from "react";
import "./businesshome.css";
import { t } from "i18next";
import { Header, TitleView, Button, BreadCrumb } from "../../components";
import businessImage from "../../../assets/svgs/postretmt/businessincome.svg";
import * as Bl from "../../../businesslogic";
import {
  INCOME_CATEGORY,
  INCOME_FREQUENCY_TYPE,
  INCOME_TYPE,
} from "../../constants";
import { getIncomePathName, getUserId } from "../../common";

const newIncome = {
  incomecategory: INCOME_CATEGORY.BUSINESS,
  userid: '',
  frequencytype: INCOME_FREQUENCY_TYPE.YEARLY,
  incomefrequency: 1,
  incomeamount: 0,
  incomestartyear: 0,
  incomeendyear: 0,
  incometype: INCOME_TYPE.RECURRING_PERPETUAL,
  incomegrowthrate: 0,
  incomedescription: "",
  incomestartage: 0,
  incomeendage: 0,
};
class BusinessHomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newIncomeData: new Bl.Income({ ...newIncome, userid: getUserId() }),
      incomeData: [],
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddButton() {
    this.props.navigate("/businessdetails", {
      state: { incomeData: this.state.newIncomeData, isEditView: false },
    });
  }



  renderNavView() {
    const items = getIncomePathName("Business");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("businessTitle");
    return <TitleView title={title} />;
  }

  renderImage() {
    return (
      <img src={businessImage} alt="businessImage" className="bhp_image" />
    );
  }

  renderDetails() {
    return (
      <span className="bhp_details_text">
        {t("businessInfo")}
      </span>
    );
  }
  renderButton() {
    return (
      <div id="bhp_button_view">
        <Button
          buttonName={t("businessButton")}
          onPressButton={this.onPressAddButton.bind(this)}
        />
      </div>
    );
  }

  render() {
    return (
      <div id="bhp_container">
        {this.renderNavView()}
        <div id="bhp_inner_container">
          {this.renderTitleView()}
          {this.renderImage()}
          {this.renderDetails()}
          {this.renderButton()}
        </div>
      </div>
    );
  }
}
export default BusinessHomePage;
